/**
 * distribution list control module
 */
import { API_URL, requestData } from "../utils";

export default class DistributionListModule {
  create(enterprise_id, entity_id = "", distribution_list) {
    return requestData(
      "POST",
      `/bulk/distribution_list?enterprise_id=${enterprise_id}&entity_id=${entity_id}`,
      distribution_list,
    );
  }
  getQuery(query) {
    return requestData("GET", `/bulk/distribution_list`, query);
  }
  requestQueryLink(query, link = "/bulk/distribution_list") {
    return requestData("GET", link, query);
  }
  update({
    enterprise_id,
    entity_id = "",
    list_id,
    name,
    description,
    allow_duplicate_entries = false,
    time_last_updated
  }) {
    return requestData(
      "PUT",
      `/bulk/distribution_list?enterprise_id=${enterprise_id}&list_id=${list_id}&entity_id=${entity_id}`,
      { name, description, allow_duplicate_entries, time_last_updated },
    );
  }
  delete({ enterprise_id, entity_id = "", list_id }) {
    return requestData(
      "DELETE",
      `/bulk/distribution_list?enterprise_id=${enterprise_id}&list_id=${list_id}&entity_id=${entity_id}`,
    );
  }

  optOut(enterprise_id, list_id, phone_numbers = [], optOutAll) {
    return requestData(
      "POST",
      `/bulk/optout?enterprise_id=${enterprise_id}&list_id=${list_id}`,
      {
        phone_numbers,
        optOutAll,
      },
    );
  }

  reOptIn(enterprise_id, list_id, phone_numbers = []) {
    return requestData("POST", `/bulk/re-opt-in`, {
      enterprise_id,
      list_id,
      phone_numbers,
    });
  }

  getUnsubscribedUsers({ enterprise_id, list_id, entity_id = "" }) {
    return requestData(
      "GET",
      `/bulk/unsubscribed_distribution_list_entry?enterprise_id=${enterprise_id}&list_id=${list_id}&entity_id=${entity_id}`,
    );
  }

  entries = {
    add(enterprise_id, entity_id = "", list_id, distribution_list_entries) {
      return requestData(
        "POST",
        `/bulk/distribution_list_entry?enterprise_id=${enterprise_id}&list_id=${list_id}&entity_id=${entity_id}`,
        { distribution_list_entries },
      );
    },
    async validateCSVDirect(enterprise_id, _entity_id = "", list_id, file) {

      const jwt = await fetch(`${API_URL}/token`, {
        method: "get",
        mode: "cors",
        credentials: "include",
      }).then((res) => res.text());

      const formData = new FormData();
      formData.append("file", new Blob([file], { type: "text/csv" }), file.name);

      const headers = new Headers();
      headers.append("distribution-list-id", list_id);
      headers.append("enterprise-id", enterprise_id);
      headers.append("entity-id", _entity_id);
      headers.append("Authorization", `Bearer ${jwt}`);

      return fetch(`${API_URL}/bulk/upload/validate/distribution_list/csv`, {
        method: "post",
        body: formData,
        mode: "cors",
        headers,
      }).then(
        (res) => {
          return res.json();
        },
        (err) => console.log(err),
      );
    },

    async addCSVDirect(
      enterprise_id,
      _entity_id = "",
      list_id,
      file,
      enable_correction,
      country,
    ) {
        const headers = new Headers();
        headers.append("distribution-list-id", list_id);
        headers.append("enterprise-id", enterprise_id);
        headers.append("entity-id", _entity_id);
        headers.append("auto-correct-phone-number-enabled", enable_correction);
        headers.append("auto-correct-phone-number-country", country);

      const formData = new FormData();
      formData.append("file", new Blob([file], { type: "text/csv" }), file.name);

      const jwt = await fetch(`${API_URL}/token`, {
        method: "get",
        mode: "cors",
        credentials: "include",
      }).then((res) => res.text());

      headers.append("Authorization", `Bearer ${jwt}`);

      return fetch(`${API_URL}/bulk/upload/distribution_list/csv`, {
        method: "post",
        body: formData,
        mode: "cors",
        headers,
      }).then(
        (res) => {
          return res.json();
        },
        (err) => console.log(err),
      );
    },
    //LEGACY-- features other than DL are using this flow, but we want to migrate to the above ^-- kind of. the token thing is wild.
    addCSV(enterprise_id, entity_id = "", list_id, files) {
      return fetch(
        API_URL +
          `/bulk/upload/distribution_list/csv?distribution-list-id=${list_id}&enterprise-id=${enterprise_id}&entity_id=${entity_id}`,
        {
          method: "post",
          body: files,
          mode: "cors", // same-origin, no-cors
          credentials: "include", // omit, include
        },
      ).then((response) => response.json());
    },
    get(enterprise_id, list_id) {
      return requestData(
        "GET",
        `/bulk/distribution_list_entry?enterprise_id=${enterprise_id}&list_id=${list_id}`,
      );
    },
    getAll({ enterprise_id, list_id, page, pageSize, entity_id = "" }) {
      return requestData(
        "GET",
        `/bulk/distribution_list_entry?enterprise_id=${enterprise_id}&list_id=${list_id}&page=${page}&pageSize=${pageSize}&entity_id=${entity_id}`,
      );
    },
    delete({ enterprise_id, entity_id = "", list_id, item_id }) {
      return requestData(
        "DELETE",
        `/bulk/distribution_list_entry?enterprise_id=${enterprise_id}&list_id=${list_id}&item_id=${item_id}&entity_id=${entity_id}`,
      );
    },
    update({ enterprise_id, entity_id = "", list_id, item_id, ...rest }) {
      return requestData(
        "PUT",
        `/bulk/distribution_list_entry?enterprise_id=${enterprise_id}&list_id=${list_id}&item_id=${item_id}&entity_id=${entity_id}`,
        { ...rest },
      );
    },
    getDistributionEntriesCsvURL(
      query,
      link = "/bulk/download/csv/distribution_list_entry",
    ) {
      return API_URL + link + "?" + new URLSearchParams(query);
    },
  };
}
